import * as React from "react";
import { Card, CardContent, Typography, CardActions, Button, Box, FormControl, FormControlLabel, Radio, InputLabel, Alert, FormLabel, } from "@mui/material";
import { Formik, FormikProps, Form, } from "formik";
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { Link, useMatch } from "react-router-dom";
import RadioGroup from '@mui/material/RadioGroup';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../store/store";
import { siteActionSelector, siteGetDataById, siteUpdateData } from "../../../store/slices/siteActionSlice";
import { Site } from "../../../types/site.type";
import Loader from "../../component/Loader";


type SiteEditPageProps = {
  //
};


const SiteEditPage: React.FC<any> = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const siteActionReducer = useSelector(siteActionSelector);
  // const siteGroupReducer = useSelector(siteGroupSelector);


  const match = useMatch("/site/edit/:id");
  const initialValues: Site = { id: "", siteCode: "", siteName: "", active: true , isScale:true, createdBy: "" };

  // React.useEffect(() => {
  //   dispatch(siteGroupGetData(""));
  // }, [])


  React.useEffect(() => {
    let id = match?.params.id;
    dispatch(siteGetDataById(id!));
  }, [])


  const showForm = ({ values, setFieldValue, isSubmitting, touched, errors, handleChange, handleBlur }: FormikProps<Site>) => {
    return (
      <Form>
        <Card>
          <CardContent sx={{ padding: 4 }}>
            <Typography gutterBottom variant="h5">
              Edit Site
            </Typography>

            <TextField id="siteName"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t('siteName')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.siteName}
              helperText={
                errors.siteName && touched.siteName
                  ? errors.siteName
                  : ''
              }
              error={
                errors.siteName && touched.siteName
                  ? true
                  : false
              } />

            {/* <FormControl style={{ marginTop: 16 }} fullWidth>
              <InputLabel htmlFor="siteGroupId">{t('siteGroupId')}</InputLabel>
              <Select
                name="siteGroupId"
                value={values.siteGroupId}
                onChange={(event) => { setFieldValue('siteGroupId', event.target.value) }}
                error={
                  errors.siteGroupId && touched.siteGroupId
                    ? true
                    : false
                }
              >
                {siteGroupReducer.result.map((item, index) => (
                  <MenuItem key={item.siteGroupCode} value={item.siteGroupCode}>
                    {item.siteGroupName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}


            <FormControl component="fieldset" style={{ marginTop: 16 }} fullWidth>
            <FormLabel>Active</FormLabel>
              <RadioGroup row name="active" onChange={(event) => { setFieldValue("active", event.currentTarget.value === "true" ? true : false) }} value={values.active}>
                <FormControlLabel control={<Radio />} value={true} label={t('active')} />
                <FormControlLabel control={<Radio />} value={false} label={t('inactive')} />
              </RadioGroup>
            </FormControl>

        
            <FormControl component="fieldset" style={{ marginTop: 16 }} fullWidth>
            <FormLabel>Scale Price</FormLabel>
              <RadioGroup row name="isScale" onChange={(event) => { setFieldValue("isScale", event.currentTarget.value === "true" ? true : false) }} value={values.isScale}>
                <FormControlLabel control={<Radio />} value={true} label={t('active')} />
                <FormControlLabel control={<Radio />} value={false} label={t('inactive')} />
              </RadioGroup>
            </FormControl>

            {siteActionReducer.isError && <Alert severity="error">{siteActionReducer.message}</Alert>}

          </CardContent>
          <CardActions>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              sx={{ marginRight: 1 }}
              disabled={siteActionReducer.isFetching}
            >
              {t('btnEdit')}
            </Button>
            <Button component={Link} to="/site" variant="outlined" fullWidth>
              {t('btnCancel')}
            </Button>
          </CardActions>
        </Card>
      </Form>
    );
  };

  const inputRequired = t('inputRequired');
  const validationSchema = Yup.object().shape({
    siteCode: Yup.string().required(inputRequired),
    siteName: Yup.string().required(inputRequired),
  });


  if (siteActionReducer.isFetching) {
    return <><Loader /></>
  }


  return (
    <Box>
      <Formik
        validationSchema={validationSchema}
        enableReinitialize={true}
        initialValues={siteActionReducer.result ? siteActionReducer.result! : initialValues}
        onSubmit={(values, { setSubmitting }) => {
          dispatch(siteUpdateData(values));
          setSubmitting(false);
        }}
      >
        {(props: any) => showForm(props)}
      </Formik>
    </Box>
  );
};

export default SiteEditPage;
